import { inject, Injectable, signal } from '@angular/core';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, EMPTY, switchMap, tap } from 'rxjs';
import { Auth } from '@/app/core/services/auth';
import { AuthService, GetAuthProfileResponse } from '@/app/core/services/auth-service';

@Injectable({
  providedIn: 'root',
})
export class Profile {
  private readonly auth = inject(Auth);
  private readonly authService = inject(AuthService);

  private _authProfile = signal<GetAuthProfileResponse['data'] | null>(null);
  authProfile = this._authProfile.asReadonly();

  private _spaces = signal<{ id: number, name: string }[]>([]);
  spaces = this._spaces.asReadonly();

  constructor() {
    toObservable(this.auth.authToken)
      .pipe(
        takeUntilDestroyed(),
        switchMap((authToken) => {
          if (!authToken) {
            this.clearUserProfile();
            return EMPTY;
          }

          return this.authService.apiGetAuthProfile().pipe(
            tap((res) => {
              this._authProfile.set(res.data);
              this._spaces.set(res.data.spaces);
            }),
            catchError(() => {
              this.clearUserProfile();
              return EMPTY;
            }),
          );
        }),
      )
      .subscribe();
  }

  clearUserProfile() {
    this._authProfile.set(null);
  }
}
